export default {
  asset: {
    upload: {
      errorType: '{type} file type is not allowed to upload.',
      errorFileSize:
        'File size exceeds limit. Maximum size cannot exceed {size}.',
      errorFileDirection: 'File Ratio Mismatch',
      label: 'Upload',
      describe: 'Drag and drop files to upload instantly',
      rules:
        'Video: mp4/avi/mkv/flv/mov/webm \n Image: jpg/png/gif\n Audio: mp3/aac/wav \n Other: psd/zip',
      imageRules: 'Images',
      videoRules: 'Video',
      audioRules: 'Audio',
      otherRules: 'Others',
      selectall: 'Select All',
      selected: '{selectNum} Selected',
      capacity: 'Storage Space',
      filetips: 'The file name already exists, please rename it.',
      exists: 'File already exists.',
      describing: '{successNum} / {selectNum} files has been uploaded.',
      success: '{selectNum} files uploaded successfully.',
      total:
        '{failNum} files uploaded failed, {successNum} successfully uploaded.',
      completed: 'Uploaded Completed',
      failed: 'Upload Failed',
      fontRules: 'Font',
    },
    label: 'Creative Assets',
    download: {
      maxDownload: 'It is not allowed to download more than 500M.',
      filePack: 'Packaging',
      fileDownload: 'Downloading',
    },
    rules: {
      nameNoSpecialCharacter: 'Special characters are not supported.',
      nameNoEmpty: 'Name cannot be empty',
      success: 'Edit Successfully',
    },
    table: {
      describe:
        "· If the asset is already used by the project, deleting the asset will affect project editing.<br />\\n · If the assets include screen recording files, the screen recording files cannot be deleted directly. If you want to delete the screen recording files, you need to delete the related screen recording project.<br />\\n · This can't be undone. Are you sure to delete?",
      name: 'Asset Name and ID',
      assetssource: 'Source',
      assetstype: 'Types',
      format: 'Format',
      size: 'Size',
      updatetime: 'Updated Time',
      batch: {
        delete: {
          label: 'Delete {num} Material',
          describe:
            "If the resource is already used by the project, deleting it will affect project editing.\nIf the resource includes screen recording files, the screen recording files cannot be deleted directly. If you want to delete the screen recording files, you need to delete the related screen recording projects.\nThis can't be undone. Are you sure to delete?",
        },
        download: {
          label: 'Download File',
          selected: '2 file items selected',
          total: 'Total {fileSize}',
          forbidTip: 'Transcoding failed, unable to download.',
        },
      },
      status: 'Transcoding Status',
      operation: {
        editName: 'Edit Asset Name',
        rename: 'Rename',
        ai: 'AI Video Generating',
        video: 'Video Editing',
        videoDisableTip: 'Supports MP4、MOV format, max 500MB.',
      },
    },
    describe:
      'Manage assets that need to be used in the editing of creative tools (video/screen recording/playable).',
    tab: {
      label: 'Creative Assets',
    },
    uploading: 'Uploading',
    creating: 'Uploading',
    filter: {
      assetname: 'Asset Name',
      assetid: 'Asset ID',
      createtime: 'Creation Time',
      updatetime: 'Updated Time',
      size: 'File Size',
      format: 'Format',
      audio: 'Audio',
      image: 'Images',
      video: 'Video',
      other: 'Others',
      types: 'Types',
      h5: 'H5',
      font: 'Font',
      psd: 'PSD',
      zip: 'Zip File',
      recordfile: 'Screen Recording Asset File',
    },
    advanced: {
      tips: 'Advanced Filter',
      direction: 'Orientation',
      horizontal: 'Landscape',
      vertical: 'Portrait',
      square: 'Square',
      proportion: 'Ratio',
      duration: 'Duration',
      second: 'Second',
      minute: 'Minute',
      hour: 'Hour',
      code: 'Bitrate',
      frame: 'Frame Rate',
      filesize: 'Size',
      size: 'Dimension',
      date: 'Date',
      createdate: 'Creation Date',
      updatedate: 'Updated Date',
      nowadays: 'Today',
      last7days: 'Past Week',
    },
    result: 'Result',
    gridtips: 'Grid View',
    listtips: 'List View',
    multiple: 'Multiple Selection',
    details: {
      message: 'Asset Details',
      name: 'Asset Name',
      placeholder: 'Please input Asset Name',
      description: 'Description',
      desplaceholder: 'Please input  Description',
      source: 'Source',
      type: 'Types',
      label: 'Label',
      folder: 'Folder',
      founder: 'Creator',
      lastupdated: 'Person Last Updated',
      updatedtime: 'Updated Time',
      information: 'File Information',
    },
    transcode: {
      transcoding: 'Transcoding',
      error: 'Transcoding Failed',
      active: 'Transcoding Successful',
    },
  },
}
